import api from './api';

const authService = {
  // Register a new user
  async register(email, password, fullName) {
    try {
      const response = await api.post('/auth/register', {
        email,
        password,
        fullName,
      });

      // If registration returns a token, store it
      const token = response.data.token || response.data.access_token || response.data.data?.token;

      if (token) {
        this.setToken(token);
      }

      if (response.data.user) {
        this.setUser(response.data.user);
      }

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Login user
  async login(email, password) {
    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      });

      // Store token and user data
      console.log('Login Response:', response.data);

      const token = response.data.token || response.data.access_token || response.data.data?.token;

      if (token) {
        this.setToken(token);
        console.log('Token successfully stored:', token.substring(0, 10) + '...');
      } else {
        console.error('CRITICAL: No token found in login response!', response.data);
      }

      if (response.data.user) {
        this.setUser(response.data.user);
      } else if (response.data.data?.user) {
        this.setUser(response.data.data.user);
      }

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Logout user
  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear local storage regardless of API call result
      this.clearAuth();
    }
  },

  // Request password reset
  async forgotPassword(email) {
    try {
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Reset password with token
  async resetPassword(token, password) {
    try {
      const response = await api.post('/auth/reset-password', {
        token,
        password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Helper for cookies
  setCookie(name, value, days = 7) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  },

  getCookie(name) {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=');
      return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, '');
  },

  deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  },

  // Token management
  setToken(token) {
    this.setCookie('taasa_token', token);
  },

  getToken() {
    return this.getCookie('taasa_token');
  },

  removeToken() {
    this.deleteCookie('taasa_token');
  },

  // User management
  setUser(user) {
    if (user) {
      this.setCookie('taasa_user', JSON.stringify(user));
    }
  },

  getUser() {
    const userStr = this.getCookie('taasa_user');
    try {
      return userStr ? JSON.parse(userStr) : null;
    } catch (e) {
      return null;
    }
  },

  removeUser() {
    this.deleteCookie('taasa_user');
  },

  // Clear all auth data
  clearAuth() {
    this.removeToken();
    this.removeUser();
  },

  // Check if user is authenticated
  isAuthenticated() {
    return !!this.getToken();
  },

  // Get user role
  getUserRole() {
    const user = this.getUser();
    return user?.role || null;
  },

  // Role checking helpers
  isAdmin() {
    return this.getUserRole() === 'ADMIN';
  },

  isProvider() {
    return this.getUserRole() === 'PROVIDER';
  },

  isUser() {
    return this.getUserRole() === 'USER';
  },
};

export default authService;
